import React from 'react'
import Logo from '../../images/logo.png'

import './styles.css'

export const Header = () => {
	return (
		<header id="header">
			<a href="/home">
				<img src={Logo} alt="schiefler logo"></img>
			</a>
		</header>
	)
}
